import { getFormatter } from 'next-intl/server';

import { GetBlogPostsQuery } from '@/fo/api/magento';
import { RubricArticle } from '@/fo/ui/article/section/top-five';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { urlMap } from '../consts';
import { BlogPageType } from '../types';

export const mapAnotherPost = async (
  posts: GetBlogPostsQuery['mpBlogPosts'],
  type: BlogPageType
): Promise<RubricArticle | null> => {
  const format = await getFormatter();

  const firstPost = posts?.items?.find((post) => !!post);

  if (
    !firstPost ||
    !firstPost.post_id ||
    !firstPost.name ||
    !firstPost.url_key
  ) {
    return null;
  }

  const mapCategories =
    firstPost.categories?.items
      ?.map((category) => {
        if (!category?.url_key || !category?.name) {
          return null;
        }
        return {
          id: category.url_key,
          title: category.name,
          color: category.color ?? undefined,
          url: `/about-skin/${urlMap[type]}/categories/${category.url_key}`
        };
      })
      .filter((category) => !!category) ?? [];

  return {
    id: firstPost.post_id.toString(),
    title: firstPost.name,
    description: firstPost.short_description ?? '',
    imageUrl: firstPost.image
      ? '/' + firstPost.image
      : staticMediaUrl('blog/placeholder.png'),
    url: `/about-skin/${urlMap[type]}/${firstPost.url_key}`,
    tags: mapCategories,
    meta: {
      rating: firstPost.rating_summary ?? undefined,
      readTime: firstPost.time_to_read ?? undefined,
      date: firstPost.publish_date
        ? format.dateTime(new Date(firstPost.publish_date), {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
          })
        : undefined
    }
  };
};
